import { useEffect, useRef } from 'react';
import { useFragment, graphql } from 'react-relay';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useEuEligible } from './useEuEligible';

import type { useTrackExposedReturns_viewer$key } from './__generated__/useTrackExposedReturns_viewer.graphql';

const viewerFragment = graphql`
    fragment useTrackExposedReturns_viewer on Viewer {
        ...useEuEligible_viewer @arguments(userCountryCode: $userCountryCode)
        user(userId: $userId) @include(if: $fetchUser) {
            isVerifiedTrade
        }
    }
`;

export const useTrackExposedReturns = ({
    viewer: viewerRef,
}: {
    viewer?: useTrackExposedReturns_viewer$key | null;
}): void => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const isEuEligible = useEuEligible({ viewer });
    const isTrade = viewer?.user?.isVerifiedTrade;
    const hasFiredTracking = useRef<boolean>(false);

    useEffect(() => {
        if ((isEuEligible || isTrade) && !hasFiredTracking.current) {
            trackAbTestV2Variant('ReturnsonPDP');
            hasFiredTracking.current = true;
        }
    }, [isEuEligible, isTrade]);
};
